import React from "react";
import * as Preloader from "../../../../../../common-deprecated/styles/v2/lexus/custom/Preloader";
import { useModelFilterSelector } from "../../../redux/store";
import ModelResult from "./ModelResult";
import NoResults from "./NoResults";
import ComingSoonBlock from "./ComingSoonBlock";
import * as Styles from "./styles/ModelResultStyles";
import { showComingSoon } from "../../../utils/helpers";
import { ModelFilterLabel } from "../../../utils/labels";
import { SkipLink } from "../../../../../../common-deprecated/styles/v2/lexus/utilities/ScreenreaderOnly";
import { SKIP_ID_FILTERS, SKIP_ID_RESULTS } from "../../../utils/constants/constants";

const ModelResultsContainer = (): JSX.Element => {
    const initialized = useModelFilterSelector((state) => state.modelResults.initialized);
    const results = useModelFilterSelector((state) => state.modelResults.results);
    const commonSettings = useModelFilterSelector((state) => state.commonSettings);
    const comingSoonBlockConfig = useModelFilterSelector(
        (state) => state.modelFilterSettings.comingSoonBlockConfigurations,
    );

    const resultComponent = results.map((model) => (
        <ModelResult
            // eslint-disable-next-line react/no-array-index-key
            key={model.id}
            model={model}
        />
    ));

    if (comingSoonBlockConfig && showComingSoon(commonSettings, results)) {
        comingSoonBlockConfig.forEach((config, index) => {
            resultComponent.splice(
                config.position - 1,
                0,
                <ComingSoonBlock
                    comingSoonBlockConfig={config}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${index}`}
                />,
            );
        });
    }

    return (
        <>
            <Styles.Grid id={SKIP_ID_RESULTS}>
                {initialized ? (
                    <>
                        {resultComponent}
                        {!results.length && <NoResults />}
                    </>
                ) : (
                    <Preloader.Wrapper width={1} position="relative">
                        <Preloader.default data-testid="preloader" />
                    </Preloader.Wrapper>
                )}
            </Styles.Grid>
            <SkipLink href={`#${SKIP_ID_FILTERS}`}>
                <ModelFilterLabel label="modelfilterA11yButtonReturnToFilters" />
            </SkipLink>
        </>
    );
};

export default ModelResultsContainer;
